import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'toFixed'
})
export class ToFixedPipe implements PipeTransform {
    constructor() {
    }

    async transform(value: any) {
        if (typeof(value) === 'number') {
            return Math.floor(value * 100) / 100;
        } else {
            return value;
        }
    }

}
